import * as React from 'react';
import { useWindowSize } from 'react-use';

import { Footer } from 'components/Footer';
import { LanguageSelector } from 'components/LanguageSelector';
import { Logo } from 'components/Logo';
import {
  Content,
  LoginWrapper,
  NoticesContent,
  NoticesWrapper,
  PageWrapper
} from 'components/MainLayout/styled';
import { SupportOptions } from 'components/SupportOptions';
import { AppNotices } from 'components/appNotices';
import { StatusPageIssues } from 'components/statusPage/StatusPageIssues';
import { useActiveIncidentsAndAppNotices } from 'components/useActiveIncidentsAndAppNotices';
import { BREAKPOINTS } from 'utils/constants';

export function MainLayout({
  children
}: {
  children?: React.ReactNode;
}): JSX.Element {
  const { width } = useWindowSize();
  const isLaptop = width <= parseInt(BREAKPOINTS.laptop, 10);
  const { isLoading, activeIncidents, appNotices } =
    useActiveIncidentsAndAppNotices();
  const hasActiveIncidentsOrAppNotices =
    activeIncidents.length !== 0 || appNotices.length !== 0;
  const shouldDisplayIncidentsOrAppNotices =
    !isLaptop && hasActiveIncidentsOrAppNotices;

  return (
    <PageWrapper>
      <LoginWrapper>
        <Logo />
        {isLoading || !shouldDisplayIncidentsOrAppNotices ? (
          <LanguageSelector />
        ) : null}
        <Content className="animated slideInDown fast">
          {children}
          {isLaptop ? (
            <>
              <StatusPageIssues incidents={activeIncidents} />
              <AppNotices appNotices={appNotices} shouldUseCardStyles />
            </>
          ) : null}
          <SupportOptions />
          <Footer />
        </Content>
      </LoginWrapper>
      {!isLaptop ? (
        <NoticesWrapper
          className={`animated ${
            !isLoading && shouldDisplayIncidentsOrAppNotices ? 'showUpLeft' : ''
          } faster`}
        >
          <LanguageSelector isDark />
          <NoticesContent>
            <StatusPageIssues incidents={activeIncidents} />
            <AppNotices appNotices={appNotices} />
          </NoticesContent>
        </NoticesWrapper>
      ) : null}
    </PageWrapper>
  );
}
